module.exports = __webpack_public_path__ + "static/media/create-password1_mobile.bd44d450.png";